module.exports = __webpack_public_path__ + "img/michael.f9f2a32a.jpg";